export default __webpack_public_path__ + "static/transactions-synced-89f2e6d147426ed33abf1d9601687aab.svg";